import React from 'react';
import { useTranslation } from 'react-i18next';

// Each row in the project's transaction list says what kind of money movement
// it is (ClickUp 869fmxj5c): the list mixes deposits, payouts and refunds
// under one heading, "Transaktioner".
// A signed ÄTA is listed as a change to the project (ClickUp 869fnvpvp).
export type TransactionKind = 'deposit' | 'payout' | 'refund' | 'variation';

const KIND_BY_TYPE: Record<string, TransactionKind> = {
  payment_pending: 'deposit',
  payment_failed: 'deposit',
  payment_interest_waiting: 'deposit',
  payment_received: 'deposit',
  payment_cancelled: 'deposit',
  payout_ready: 'payout',
  payout_pending: 'payout',
  payout_booked: 'payout',
  payout_failed: 'payout',
  milestone_released: 'payout',
  ping_payout_confirmed: 'payout',
  payment_refund: 'refund',
  payment_refund_reversed: 'refund',
  payment_chargeback: 'refund',
  payment_chargeback_reversed: 'refund',
};

/**
 * The kind of a timeline row, or null for rows that are neither a deposit,
 * a payout nor a refund (held funds `escrow_*` and fees `*_fee_booked`).
 */
export const transactionKindForType = (type: string | null | undefined): TransactionKind | null =>
  (type && KIND_BY_TYPE[type]) || null;

export function TransactionKindPill({ kind }: { kind: TransactionKind | null }) {
  const { t } = useTranslation();
  if (!kind) return null;
  return (
    <span className={`transaction-kind-pill is-${kind}`} data-testid="transaction-kind-pill">
      {t(`projectView.transactions.kind.${kind}`)}
    </span>
  );
}
